import { render, staticRenderFns } from "./WarehouseTabList.vue?vue&type=template&id=64418ac9&scoped=true"
import script from "./WarehouseTabList.vue?vue&type=script&lang=js"
export * from "./WarehouseTabList.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabList.vue?vue&type=style&index=0&id=64418ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64418ac9",
  null
  
)

export default component.exports